import {
  aMatchList,
  aMatchListItemPage,
  mockMatchListDetailOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const getMatchListDetailQueryHandler = ({
  name,
  description,
  timeToLive,
}) => {
  return mockMatchListDetailOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          matchList: aMatchList({
            defaultTtl: timeToLive,
            description: description,
            id: '1',
            items: aMatchListItemPage({
              hasNextPage: false,
              objects: [],
              total: 0,
            }),
            name,
            targetColumn: '1',
          }),
        },
      });
    }
  );
};

export const handlers = [
  mockMatchListDetailOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          matchList: aMatchList(),
        },
      });
    }
  ),
];
